export const pathNamePages = {
  fotoDelDia: '/fotoDelDia',
  home: '/',
  cliente: '/cliente',
  catalogo: '/catalogo',
  analisisVentas: '/analisisventas',
  tiemposReq: '/tiemposReq',
};
